import React, {Fragment} from "react";
import Card from "../../components/card/Card";
import ModalMsg from "../../components/ModalMsg";
import NsDataTable from "../../components/tabelle/NsDataTable";
import NsButtonActionsGroup from "../../components/buttons/NsButtonActionsGroup";
import NsButtonAction from "../../components/buttons/NsButtonAction";
import ModalConfirm from "../../components/ModalConfirm";

export default function ConfFrequenzeView({
                                              frequenze,
                                              translate,
                                              onRowDbClickFrequenza,
                                              showConfirm,
                                              setShowConfirm,
                                              eliminaFrequenza,
                                              frequenzaSel,
                                              show,
                                              setShow,
                                              modalMsg,
                                              onClickElimina,
                                              bottoniDx,
                                          }) {

    return (
        <Card
            icon={'fas fa-hourglass-start'}
            title={'Frequenze compilazione'}
            bottoniDx={bottoniDx}
        >
            <ModalConfirm
                show={showConfirm}
                handleClose={() => setShowConfirm(false)}
                handleOk={eliminaFrequenza}
                testo={"Sicuro di voler eliminare la frequenza: " + (frequenzaSel && frequenzaSel.codice) + "?"}/>
            <ModalMsg
                show={show}
                handleClose={() => setShow(false)}
                testo={modalMsg}/>
            <Fragment>
                <NsDataTable
                    data={frequenze}
                    columns={[
                        {
                            name: translate('Codice'),
                            selector: row => row.codice,
                            sortable: true,
                        },
                        {
                            name: translate('Descrizione'),
                            selector: row => row.descrizione,
                            sortable: true,
                        },
                        {
                            name: '',
                            selector: row => <NsButtonActionsGroup>
                                <li>
                                    <NsButtonAction
                                        href={"/upd-frequenza-comp/" + row.id_frequenza_compilazione}
                                        label={"Modifica"}
                                        icona={"fas fa-pen"}
                                    />
                                </li>
                                <li>
                                    <NsButtonAction
                                        label={"Elimina"}
                                        icona={"fas fa-trash"}
                                        onClick={() => {
                                            onClickElimina(row);
                                        }}
                                    />
                                </li>
                            </NsButtonActionsGroup>,
                            sortable: false,
                            right: true,
                        }
                    ]}
                    onRowDbClick={(row) => {
                        onRowDbClickFrequenza(row);
                    }}
                />
            </Fragment>
        </Card>
    );
}
